import { Controller } from "@hotwired/stimulus";
import React, { useEffect } from "react";
import { Root, createRoot } from "react-dom/client";
import { useForm } from "react-hook-form";
import { format, parseISO } from "date-fns";
import { DateField } from "js/components/Form";

type Fields = {
  date: Date;
};

type Props = {
  name: string;
  selectedDate: string;
};

const Wrapper = (props: Props) => {
  const formMethods = useForm<Fields>();
  const { watch, reset } = formMethods;

  useEffect(() => {
    if (props.selectedDate) {
      const date = parseISO(props.selectedDate);
      reset({ date: date });
    }
  }, [props.selectedDate]);

  let inputTagDate = "";
  const selectedDate = watch("date");
  if (selectedDate) {
    inputTagDate = format(selectedDate, "yyyy-MM-dd");
  }

  return (
    <>
      <input type="hidden" value={inputTagDate} name={props.name} />
      <DateField name="date" control={formMethods.control} />
    </>
  );
};

export default class extends Controller {
  static values = { selectedDate: String, name: String };

  readonly nameValue!: string;
  readonly selectedDateValue!: string;
  private root: Root;

  connect() {
    const container = this.element;
    this.root = createRoot(container);

    this.root.render(
      <Wrapper name={this.nameValue} selectedDate={this.selectedDateValue} />,
    );
  }

  disconnect() {
    this.root.unmount();
    this.root = null;
  }
}
